import { getCustomerId } from '@mindfulchefuk/helpers/js/authentication'

export const identifyCustomerForInAppMessaging = () => {
  const customerId = getCustomerId()
  const customerIo = window.analytics
  customerIo.identify(customerId)
}
